<template>
	<div class="page__content page__content--loader">

		<section class="race__details" :class="loadClass">
			<div class="race__details__top race__details__top--loader">

			</div>
			<div class="race__details__bottom">
				<ul class="race__details__container race__details__container--loader">

				</ul>
			</div>
		</section><!-- /.race__details -->

		<div class="page__container">
			<section class="block block--medium" :class="loadClass">
				<div class="block__header block__header--primary"><h3 class="block__title">&nbsp;</h3></div>
				<div class="block__content">

				</div>
			</section><!-- /.block.block--medium -->

			<div class="col-layout col-layout--sidebar">
				<div class="col-layout__row">
					<div class="col-layout__item">

						<section class="block block--medium block--nopad" :class="loadClass">
							<div class="block__header block__header--primary"><h3 class="block__title">&nbsp;</h3></div>
							<div class="block__content">

								<table class="table__bet table__bet--loader">
									<thead>
									<tr class="table__bet__header">
										<th><span class="visually-hidden">Casaque</span></th>
										<th><span class="visually-hidden">Numéro</span></th>
										<th><span class="visually-hidden">Infos</span></th>
										<th>Cheval</th>
										<th>Jockey</th>
										<th>Musique</th>
										<th colspan="2" align="center">Cote</th>
										<th align="center" class="table__bet__checkbox"><b>B.</b></th>
										<th align="center" class="table__bet__checkbox"><b>A.</b></th>
									</tr>
									</thead>
									<tbody>
									<tr class="table__bet__row" v-for="tp in 8" :key="'rl-'+tp">
										<td class="table__bet__cassock" colspan="10">&nbsp;</td>
									</tr>
									</tbody>
								</table><!-- /.table__bet -->


							</div>
						</section>

					</div>
					<aside class="col-layout__item col-layout__item--sidebar">

						<section class="bet-form bet-form--loader loading-blur">


						</section><!-- /.bet-form -->


					</aside><!-- /.col-layout__item.col-layout__item--sidebar -->
				</div>
			</div><!-- /.col-layout.col-layout--sidebar -->
		</div>

	</div>
</template>
<script>
	export default {
		name: 'RaceLoader',
		data() {
			return {
				loadClass: [
					'loading-blur'
				]
			}
		},
		mounted() {

		}
	}
</script>
<style lang="scss">
	.page__content--loader {
		min-height: 70vh;
		filter: grayscale(100%);
	}

	.bet-form {
		&--loader {
			min-height: 500px;
			border-radius: 4px;
			background-color: #eaeaea;
			position: relative;
			&::before {
				content: '';
				display: block;
				width: 100%;
				height: 60px;
				background-color: #454545;
				border-top-left-radius: 4px;
				border-top-right-radius: 4px;
			}
		}
	}

	.table__bet {
		&--loader {

		}
	}

	.race__details__container--loader {
		min-height: 60px;
	}

	.race__details__top--loader {
		min-height: 80px;
	}
</style>
